<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center margin-bottom margin-top-xs">
            <div class="page-title ">单位会员权益</div>
        </div>
        <div class="classifys flex align-center">
            <router-link to="/organization/setup/information" class="classify ">单位会员</router-link>
            <router-link to="/organization/setup/sinformation" class="classify">个人会员</router-link>
            <router-link class="classify active" to="/organization/setup/rights">单位会员权益</router-link>
            <router-link class="classify" to="/organization/setup/srights">个人会员权益</router-link>
        </div>
        <el-form
            ref="noticeForm"
            :model="noticeForm"
            :rules="rules"
            class="demo-noticeForm" label-width="auto"  v-loading="init_loading">
            <el-form-item label="显示状态" prop="is_show">
                <el-radio-group v-model="noticeForm.is_show">
                    <el-radio :label="0">不展示</el-radio>
                    <el-radio :label="1">展示</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="权益说明" prop="content">
                <VueUditorWrap
                    v-model="noticeForm.content"
                    :config="myConfig"
                ></VueUditorWrap>
            </el-form-item>
            <el-form-item label="专属权益说明" prop="spe_content">
                <VueUditorWrap
                    v-model="noticeForm.spe_content"
                    :config="myConfig"
                ></VueUditorWrap>
            </el-form-item>
            <el-form-item label-width="0">
                <div class="flex justify-center">
                    <el-button
                        class="padding-lr-xl blue-btn"
                        style="width: 220px"
                        round
                        type="primary"
                        :loading="loading"
                        @click="submitForm('noticeForm')"
                    >发布
                    </el-button>

                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import {getUserTypeDesc, setUserTypeDesc} from "@/api/organiz";

export default {
    name: "rights",
    data() {
        return {
            id: '',
            myConfig: bdEditConfig(),
            noticeForm: {
                content: '',
                spe_content: '',
                is_show: 0,
            },
            rules: {
                content: [
                    {required: true, message: '请输入', trigger: 'blur'},
                ],
                spe_content: [
                    {required: true, message: '请输入', trigger: 'blur'},
                ],
            },
            loading: false,
            init_loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [2, 3], '信息设置')
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {
        VueUditorWrap
    },
    methods: {
        //  获取全部标签和会员
        async init() {
            this.init_loading = true
            let _data = await getUserTypeDesc(1)
            this.init_loading = false
            this.noticeForm.is_show = _data.data.is_show
            this.noticeForm.content = _data.data.content
            this.noticeForm.spe_content = _data.data.spe_content
            this.id = _data.data.id
        },
        //  发布通知公告
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData()
                } else {
                    this.$message.error('信息未填写完整，请检查！')
                }
            });
        },
        async submitData() {
            this.loading = true
            let _data = await setUserTypeDesc(this.id,this.noticeForm.is_show,this.noticeForm.content,this.noticeForm.spe_content)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('发布成功！')
            }
        },
    },
    filters: {

    }

}
</script>

<style lang="scss" scoped>
.warpper {
    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;

            color: #ffb400;

            &:first-child {
                border-radius: 6px 0 0 6px;
            }

            &:last-child {
                border-radius: 0 6px 6px 0;
            }

            &.active {
                background: #ffb400;
                color: #FFFFFF;
            }
        }
    }

}
</style>